import { render } from "./BaseCheckbox.vue?vue&type=template&id=b81596f8"
import script from "./BaseCheckbox.vue?vue&type=script&lang=ts"
export * from "./BaseCheckbox.vue?vue&type=script&lang=ts"
script.render = render

export default script